import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "activites", label: "Activités", testid: "nav-activites" },
  { id: "spectacles", label: "Spectacles", testid: "nav-spectacles" },
  { id: "agenda", label: "Agenda", testid: "nav-agenda" },
  { id: "apropos", label: "À propos", testid: "nav-apropos" },
  { id: "galerie", label: "Galerie", testid: "nav-galerie" },
  { id: "contact", label: "Contact", testid: "nav-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAFAFA]/85 border-b border-black/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 md:h-20">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="nav-home"
          className="flex items-center gap-2 hover:opacity-70 transition-opacity"
        >
          <img src="/images/logo.png" alt="Atelier Loraine B" className="h-11 md:h-12 w-auto rounded-lg" />
          <span className="font-display text-2xl md:text-3xl tracking-wide hidden sm:inline">
            L'ATELIER<span className="text-[#FF6B6B]"> · </span>LORAINE B
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={l.testid}
              className="font-sans text-sm font-medium tracking-wider uppercase hover:underline underline-offset-8 decoration-2"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#FAFAFA] border-t border-black/10" data-testid="nav-mobile-menu">
          <div className="flex flex-col px-4 py-6 gap-4">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                data-testid={`${l.testid}-mobile`}
                className="text-left font-sans text-base font-medium uppercase tracking-wider"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
